'use client';

import { useEffect } from 'react';

export default function FirebaseAnalytics() {
  useEffect(() => {
    (async () => {
      if (typeof window !== 'undefined') {
        const { analytics } = await import('./firebase');
        if (analytics) {
          console.log('Welcome to KBFC Fans club');
        }
      }
    })();
  }, []);

  return <></>;
}
